import { createDivInBody } from './utils'
import ModalContainer from './ModalContainer.vue'
const PluginCore = (Vue, options = {}) => {
  const context = {
    root: null,
    componentName: options.componentName || 'Modal'
  }
  const showViewModal = (...args) => {
    return context.root.__modalContainer.show(...args)
  }
  /**
   * Creates a container for modals in the root Vue component.
   *
   * @param {Vue} parent
   */
  const setDynamicModalContainer = parent => {
    context.root = parent
    const elementContainer = createDivInBody()
    // eslint-disable-next-line
    new Vue({
      parent,
      render: h => h(ModalContainer)
    }).$mount(elementContainer)
  }

  return {
    context,
    setDynamicModalContainer,
    show: showViewModal // 推荐使用
  }
}

export default PluginCore



// WEBPACK FOOTER //
// ./src/utils/plugins/zModel/PluginCore.js